module.exports = __webpack_public_path__ + "assets/images/01_73b8e3c4f418ccee3fad87caad911ba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-one/gameplay/01.png
// module id = 204
// module chunks = 0